module.exports = __webpack_public_path__ + "assets/img/base.8fed42cc.webp";